<template>
  <!--begin::Container-->
  <div id="kt_content_container" class="container-xxl my-5">
    <ol class="breadcrumb text-muted fs-6 fw-bold mb-3">
      <li class="breadcrumb-item pe-2">
        <a href="/" class="fs-8 pe-2 text-gray-500 text-hover-primary">
          Dashboard
        </a>
      </li>
      <li class="breadcrumb-item pe-2">
        <a href="/en/products" class="fs-8 pe-2 text-gray-500 text-hover-primary">
          Packages
        </a>
      </li>
      <li class="breadcrumb-item pe-2">
        <a :href="`/shop#${$store.state.curProduct.productCategory}`"
          class="fs-8 pe-2 text-gray-500 text-hover-primary">
          {{ $store.state.curProduct.categoryName }}
        </a>
      </li>
      <li class="breadcrumb-item pe-2 text-primary fs-8">
        <a :href="`/shop/r/${$store.state.curProduct.id}`">
          {{ $store.state.curProduct.productName }}
        </a>
      </li>
      <li v-if="hafezliCur_Unit > -1"
        class="breadcrumb-item pe-2 text-primary fs-8">
        <a :href="`/shop/r/${$store.state.curProduct.id}`">
          {{ $store.state.curProduct.productChapters[hafezliCur_Unit] }}
        </a>
      </li>
      <!-- <li
        v-if="hafezliCur_Unit_Lesson && hafezliCur_Unit_Lesson['lead'] && hafezliCur_Unit_Lesson['lead']['title'] && displayStep > 0"
        class="breadcrumb-item pe-2 text-primary fs-8">
        <a :href="`/shop/r/${$store.state.curProduct.id}`">
          {{ sessionStep }}
        </a>
      </li> -->
    </ol>
    <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start mt-10">
      <div
        class="shadow bg-white rounded p-5 col-12 col-lg-3 d-flex flex-column justify-content-start align-items-center">
        <h2 class="fs-1">Table of content</h2>
        <div class="d-flex flex-column gap-5 scroll-x mt-5 justify-content-between w-100 pb-3">
          <div v-for="(topic, index) in hafezliTableOfContent" :key="index"
            class="d-flex flex-column gap-2 align-items-start justify-center-start min-w-150px">
            <button style="flex: 0 0 30px; height: 30px; width: 30px;"
              class="p-1 text-start btn btn-outline rounded text-center w-100"
              :class="displayStep == index ? 'active btn-primary' : 'btn-secondary'"
              @click="hafezliNewStep(index, index > 0 ? 'topic' : 'basic')">
              {{ index > 0 ? `${topic.title}` : topic.title }}
            </button>
            <div v-if="displayStep == index && hafezliCur_Unit_Lessons.length > 0"
              class="d-flex flex-column gap-2 justify-content-end step__steps w-100 p-1">
              <button v-for="(lesson, sIndex) in hafezliCur_Unit_Lessons" :key="sIndex"
                style="flex: 0 0 30px;" class="mx-3 text-start btn btn-outline rounded-3 text-center p-0"
                :class="sIndex == hafezliCur_Lesson ? 'active btn-primary h-lesson-130' : 'btn-secondary h-lesson-30'"
                @click="hafezliNewStep(sIndex, 'lesson')">
                {{ lesson }}
                <div v-if="hafezliCur_Lesson > -1 && hafezliCur_Lesson == sIndex"
                  class="d-flex flex-column gap-2 justify-content-end step__steps w-100 p-1">
                  <button v-for="(session, sIndex) in hafezliCur_Unit_Lesson_Sessions" :key="sIndex"
                    style="flex: 0 0 30px; height: 30px;" class="mx-3 text-start btn btn-outline rounded-3 text-center p-0"
                    :class="sessionStep == session.name ? 'active btn-primary' : 'btn-secondary'"
                    @click="hafezliNewStep(session.name, 'session')">
                    {{ session.title }}
                  </button>
                </div>
              </button>
            </div>
          </div>
          <div v-if="index > 0" class="steps__connector"></div>
        </div>
      </div>
      <div class="col-12 col-lg-8 d-flex flex-column justify-content-center align-items-center mt-5 mt-lg-0">
        <div class="w-100">
          <div v-if="displayStep == 0" class="card card-flush shadow-sm w-100">
            <div class="card-header p-8">
              <div class="card-title">
                <h1>
                  <i class="bi bi-box fs-5 me-4 text-gray-800"></i>
                  {{ $store.state.curProduct.productName }}
                </h1>
              </div>
              <div class="card-title d-flex flex-column">
                <div class="col-12 text-center">
                  <span class="me-1"> 4.5 </span>
                  <i class="bi bi-star-fill text-warning fs-6 me-1"></i>
                </div>
                <div class="col-12 text-center">
                  <a href="#" class="text-gray-500 fs-8 text-hover-primary fw-normal">
                    (1.500 Vote)
                  </a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="mb-10">
                <div class="mb-10 d-flex justify-content-center">
                  <!-- <a
                    class="d-block overlay cursor-pointer"
                    @click="
                      softBox(
                        $store.state.curProduct.productPhotos.length > 1
                          ? $store.state.curProduct.productPhotos
                          : $store.state.curProduct.productPhotos[0]
                      )
                    "
                  >
                    <div
                      class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded h-400px w-100 bg-secondary"
                      :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${$store.state.curProduct.productPhotos[0]});`"
                    ></div>
                    <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                      <i class="bi bi-eye-fill fs-2x text-white"></i>
                    </div>
                  </a> -->
                  <div class="mw-650px"
                    v-if="commonVideosExt.indexOf($store.state.curProduct.productPhotos[0].split('.')[1]) > -1">
                    <video controls controlsList="nodownload" class="w-100 rounded" style="object-fit: contain">
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${$store.state.curProduct.productPhotos[0]}`"
                        type="video/mp4" />
                      Your browser does not support the audio tag.
                    </video>
                  </div>
                  <div v-else>
                    <img class="w-100 rounded"
                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${$store.state.curProduct.productPhotos[0]}`"
                      :alt="$store.state.curProduct.productPhotos[0]">
                  </div>
                </div>
                <div class="d-flex flex-row justify-content-between mb-10">
                  <div class="col-12 text-gray-800 fs-4">
                    <i class="bi bi-play-fill text-gray-600 me-2 fs-4"></i>
                    {{ $store.state.curProduct.productSummary }}
                  </div>
                  <div class="d-none col-4 d-flex flex-column justify-content-between text-start text-gray-600 fs-5">
                    <div class="col-12">
                      <span class="me-2">تاریخ انتشار:</span>
                      <span class="fw-boldest">{{
                        $store.state.curProduct.productDate
                      }}</span>
                    </div>
                    <div class="col-12">
                      <span class="me-2 fw-boldest">1000</span>
                      <span class="">دانش آموز</span>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-stack">
                  <a href="" class="link-dark d-flex align-items-center">
                    <div class="symbol symbol-circle symbol-40px">
                      <img
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${$store.state.curProduct.profilePhoto}`"
                        alt="" class="me-2" />
                    </div>
                    <div class="d-flex flex-column text-gray-600 fs-4">
                      <span> {{ $store.state.curProduct.profileFullName }}</span>
                      <span></span>
                    </div>
                  </a>
                  <div class="d-flex text-gray-500">
                    <a href="" class="text-hover-primary"><i class="bi bi-heart fs-3 mx-2"></i></a>
                    <a href="" class="text-hover-primary"><i class="bi bi-bookmark-plus fs-3 mx-2"></i></a>
                    <a href="" class="text-hover-primary"><i class="bi bi-cloud-download fs-3 mx-2"></i></a>
                    <a href="" class="text-hover-primary"><i class="bi bi-share fs-3 mx-2"></i></a>
                  </div>
                </div>
                <div class="separator separator-content my-10"></div>
                <div class="" v-html="$store.state.curProduct.productReview"></div>
              </div>
            </div>
          </div>
          <div v-else-if="lessonDisplay && hafezliCur_Lesson > -1" class="card card-flush shadow-sm w-100">
            {{ hafezliCur_Unit_Lesson[sessionStep.name] }}
            <div v-if="sessionStep == 'lead'" class="card-body">
              <h1>
                {{ hafezliCur_Unit_Lesson["lead"] && hafezliCur_Unit_Lesson["lead"]["title"] ? hafezliCur_Unit_Lesson["lead"]["title"] : hafezliCur_Unit_Lesson["lead"] }}
              </h1>
              <p>
                {{ hafezliCur_Unit_Lesson["lead"]['summary'] }}
              </p>
              <div class="row justify-content-center">
                <div v-for="(file, fi) in hafezliCur_Unit_Lesson['lead']['files']"
                  :key="fi" class="mt-10"
                  :class="(typeof file == 'string' && file && file.split('.') && file.split('.').length > 0 && commonImagesExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                    (file['filename'] && file['filename'].split('.') && commonImagesExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1) ? 'w-50' : 'w-100'">
                  <div
                    v-if="(typeof file == 'string' && file && file.split('.') && commonVideosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) || (file['filename'] && file['filename'].split('.') && commonVideosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <video controls controlsList="nodownload" class="w-100 h-400px rounded" style="object-fit: contain">
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="video/mp4" />
                      Your browser does not support the audio tag.
                    </video>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                      <!-- <div v-if="part['formObj'] && part['formObj']['formJson'] && part['formObj']['formJson'][fi] && !part['formObj']['formJson'][fi]['ansStatus']" class="d-flex flex-center my-5">
                        <button type="button" class="btn btn-primary" @click="submitAnswer(part['formObj'], 0)">Submit your Answer</button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file.split('.') && file.split('.').length > 0 && commonAudiosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonAudiosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <audio class="w-100" controls>
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="audio/mpeg" />
                      Your browser does not support the audio tag.
                    </audio>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file && file.split('.') && file.split('.').length > 0 && commonImagesExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonImagesExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)"
                    class="row justify-content-center align-items-center">
                    <div class="mb-10 col-11 p-3">
                      <a class="d-block overlay cursor-pointer" @click="softBox(file)">
                        <div
                          class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded w-100 h-200px bg-secondary"
                          :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']});`">
                        </div>
                        <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                          <i class="bi bi-eye-fill fs-2x text-white"></i>
                        </div>
                      </a>
                      <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                        <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                          placeholder="Write down your answer"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="hafezliCur_Unit_Lesson['lead']['question']" class="d-flex flex-center mt-5">
                  <button v-if="!formDisabled" type="button" class="btn btn-primary" @click="submitAnswer(quiz, qi)">
                    Submit your Answer
                  </button>
                </div> -->
              </div>
              <h2 class="mt-10">
                Description
              </h2>
              <div v-html="hafezliCur_Unit_Lesson['lead']['description']">
              </div>
              <div v-if="hafezliCur_Unit_Lesson['lead'].quizes[0].question.length > 0"
                class="border border-1 rounded border-dashed border-gray-400 p-3 mt-10">
                <h2>
                  Quiz
                </h2>
                <div
                  v-if="hafezliCur_Unit_Lesson && hafezliCur_Unit_Lesson['lead'] && hafezliCur_Unit_Lesson['lead'].quizes">
                  <div v-for="(quiz, qi) in hafezliCur_Unit_Lesson['lead'].quizes"
                    :key="qi" class="d-flex flex-column mb-5"
                    :class="qi < hafezliCur_Unit_Lesson['lead'].quizes.length - 1 ? 'pb-3 border-bottom border-bottom-1 border-dark' : ''">
                    <!-- <h4>QA {{ fi + 1 }}. <span v-html="f.question"></span></h4> -->
                    <div class="mb-5 w-100" v-if="quiz.type == 'clozeTest'">
                      <div
                        class="w-100 border border-dark rounded row justify-content-center align-items-center p-3 gap-1">
                        <span v-for="o in quiz.answer" :key="o"
                          class="border border-1 border-dark rounded fs-6 col text-center p-2"
                          :class="o.length > 0 ? '' : 'd-none'">{{ o }}</span>
                      </div>
                    </div>
                    <p class="fs-1" v-html="quiz.question"></p>
                    <h6 v-if="quiz.summary && quiz.summary.length > 0" class="text-danger ms-2">
                      Tip: {{ quiz.summary }}
                    </h6>
                    <h6 v-if="quiz.reference && quiz.reference.length > 0" class="text-dark ms-2">
                      Reference: {{ quiz.reference }}
                    </h6>
                    <div>
                      <div v-if="quiz.type == '2choices' || quiz.type == '3choices' || quiz.type == '4choices'">
                        <div class="row justify-content-center align-items-center">
                          <div v-for="o in quiz.answer" class="px-7 py-5 col-12 col-lg-6 p-2"
                            :class="o.length > 0 ? '' : 'd-none'" :key="o">
                            <div
                              class="col-12 d-flex flex-row justify-content-between align-items-center border border-dashed rounded p-5"
                              :class="formDisabled && o == quiz.answer[0] ? 'border-success' : 'border-dark'"
                            >
                              <label class="col-11 fs-5 fw-bolder form-label m-0">
                                <img v-if="commonImagesExt.indexOf(o.split('.')[1]) > -1" class="w-100 rounded"
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${o}`" :alt="o">
                                <span v-else>{{ o }}</span>
                              </label>
                              <input v-if="formStatus" :disabled="formDisabled"
                                type="radio"
                                :checked="formDisabled && o == hafezliAnsForm_lead[qi]['value']"
                                class="form-check-input p-4" @click="setRadioGroup('lead', qi, o)"
                                :class="formDisabled && o == quiz.answer[0] ? 'border-success bg-success' : 'border-dark'"
                                :name="`${quiz.type}_${qi}`" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'shortAns'">
                        <div class="w-100">
                          <input v-if="formStatus" :disabled="formDisabled" class="form-control form-control-solid p-4"
                            v-model="hafezliAnsForm_lead[qi]['value']"
                            type="text"
                            :class="formDisabled ? hafezliAnsForm_lead[qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                            placeholder="Answer here" />
                          <div v-if="formDisabled && hafezliAnsForm_lead[qi]['value'] != quiz.answer[0]"
                            class="border border-success bg-light w-100 mt-2 rounded p-4"
                          >
                            {{ quiz.answer[0] }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'longAns'">
                        <div class="w-100">
                          <textarea v-if="formStatus" :disabled="formDisabled"
                            v-model="hafezliAnsForm_lead[qi]['value']"
                            :class="formDisabled ? hafezliAnsForm_lead[qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                            class="form-control form-control-solid p-4 mt-2" rows="10"
                            placeholder="Write down your answer"></textarea>
                          <div v-if="formDisabled && hafezliAnsForm_lead[qi]['value'] != quiz.answer[0]"
                            class="border border-success bg-light w-100 mt-2 rounded p-4"
                          >
                            {{ quiz.answer[0] }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'clozeTest' || quiz.type == 'blank'">
                        <div class="row justify-content-center align-items-center">
                          <div v-for="(o, oi) in quiz.answer"
                            class="px-7 py-5 col-12 col-lg-6 d-flex flex-column justify-content-between align-items-center"
                            :class="o.length > 0 ? '' : 'd-none'" :key="o">
                            <input v-if="formStatus" class="form-control form-control-solid p-4 w-100"
                              :class="formDisabled ? hafezliAnsForm_lead[qi]['value'][oi] == quiz.answer[oi] ? 'border-success' : 'border-danger' : ''"
                              v-model="hafezliAnsForm_lead[qi]['value'][oi]" type="text"
                              :placeholder="`Blank ${oi + 1} answer`" :disabled="formDisabled" />
                            <div v-if="formDisabled && hafezliAnsForm_lead[qi]['value'][oi] != quiz.answer[oi]"
                              class="border border-success bg-light w-100 mt-2 rounded p-4 w-100"
                            >
                              {{ quiz.answer[oi] }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div v-else-if="quiz.type == 'matching'">
                        In developing ...
                        <div class="d-none w-100">
                          <div class="d-flex flex-column justify-content-center align-items-center">
                            <div v-for="o in f.matchingOptions"
                              class="mt-3 d-flex flex-row justify-content-between align-items-center" :key="o">
                              <button type="button" class="btn btn-secondary">{{ o.text }}</button>
                              <button type="button" class="btn btn-secondary">{{ o.ans }}</button>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-center mt-5">
                <button v-if="!formDisabled && hafezliCur_Unit_Lesson['lead'].quizes[0].question.length > 0" type="button" class="btn btn-primary" @click="submitAnswer('lead')">
                  Submit your Answer
                </button>
              </div>
            </div>
            <div v-else-if="sessionStep == 'tasks'" class="card-body">
              <div v-for="(task, ti) in hafezliCur_Unit_Lesson['tasks']" :key="ti"
                class="border rounded p-5 border-primary mb-10">
                <h1>Context - {{ ti + 1 }}</h1>
                <div v-for="(file, fi) in task['files']" :key="fi" class="mt-10 w-100">
                  <div
                    v-if="(typeof file == 'string' && file && file.split('.') && commonVideosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) || (file['filename'] && file['filename'].split('.') && commonVideosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <video controls controlsList="nodownload" class="w-100 h-400px rounded" style="object-fit: contain">
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="video/mp4" />
                      Your browser does not support the audio tag.
                    </video>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                      <!-- <div v-if="part['formObj'] && part['formObj']['formJson'] && part['formObj']['formJson'][fi] && !part['formObj']['formJson'][fi]['ansStatus']" class="d-flex flex-center my-5">
                        <button type="button" class="btn btn-primary" @click="submitAnswer(part['formObj'], 0)">Submit your Answer</button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file.split('.') && file.split('.').length > 0 && commonAudiosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonAudiosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <audio class="w-100" controls>
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="audio/mpeg" />
                      Your browser does not support the audio tag.
                    </audio>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file && file.split('.') && file.split('.').length > 0 && commonImagesExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonImagesExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)"
                    class="row justify-content-center align-items-center">
                    <div class="mb-10 col-12 p-3">
                      <a class="d-block overlay cursor-pointer" @click="softBox(file)">
                        <div
                          class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded w-100 h-200px bg-secondary"
                          :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']});`">
                        </div>
                        <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                          <i class="bi bi-eye-fill fs-2x text-white"></i>
                        </div>
                      </a>
                      <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                        <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                          placeholder="Write down your answer"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <h2 class="mt-10">
                  Description
                </h2>
                <div v-html="task['description']">
                </div>
                <div v-if="task.quizes[0].question.length > 0"
                  class="border border-1 rounded border-dashed border-gray-400 p-3 mt-10">
                  <h2>Quiz</h2>
                  <div>
                    <div v-for="(quiz, qi) in task.quizes" :key="qi" class="d-flex flex-column mb-5"
                      :class="qi < task.quizes.length - 1 ? 'pb-3 border-bottom border-bottom-1 border-dark' : ''">
                      <!-- <h4>QA {{ fi + 1 }}. <span v-html="f.question"></span></h4> -->
                      <div v-if="quiz.question && quiz.question.length > 0">
                        <div class="mb-5 w-100" v-if="quiz.type == 'clozeTest'">
                          <div
                            class="w-100 border border-dark rounded row justify-content-center align-items-center p-3 gap-1">
                            <span v-for="o in quiz.answer" :key="o"
                              class="border border-1 border-dark rounded fs-6 col text-center p-2"
                              :class="o.length > 0 ? '' : 'd-none'">{{ o }}</span>
                          </div>
                        </div>
                        <p class="fs-1" v-html="quiz.question"></p>
                        <h6 v-if="quiz.summary && quiz.summary.length > 0" class="text-danger ms-2">
                          Tip: {{ quiz.summary }}
                        </h6>
                        <h6 v-if="quiz.reference && quiz.reference.length > 0" class="text-dark ms-2">
                          Reference: {{ quiz.reference }}
                        </h6>
                        <div>
                          <div v-if="quiz.type == '2choices' || quiz.type == '3choices' || quiz.type == '4choices'">
                            <div class="row justify-content-center align-items-center">
                              <div v-for="o in quiz.answer" class="px-7 py-5 col-12 col-lg-6 p-2"
                                :class="o.length > 0 ? '' : 'd-none'" :key="o">
                                <div
                                  class="col-12 d-flex flex-row justify-content-between align-items-center border border-dashed rounded p-5"
                                  :class="formDisabled && o == quiz.answer[0] ? 'border-success' : 'border-dark'">
                                  <label class="col-11 fs-5 fw-bolder form-label m-0">
                                    <img v-if="commonImagesExt.indexOf(o.split('.')[1]) > -1" class="w-100 rounded"
                                      :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${o}`" :alt="o">
                                    <span v-else>{{ o }}</span>
                                  </label>
                                  <input v-if="formStatus" :disabled="formDisabled"
                                    :checked="formDisabled && o == hafezliAnsForm_tasks[ti][qi]['value']"
                                    type="radio" class="form-check-input p-4" @click="setRadioGroup(ti, qi, o, 'tasks')"
                                    :class="formDisabled && o == quiz.answer[0] ? 'border-success bg-success' : 'border-dark'"
                                    :name="`${quiz.type}_${qi}`" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-else-if="quiz.type == 'shortAns'">
                            <div class="w-100">
                              <input v-if="formStatus" :disabled="quiz['answerStatus']"
                                class="form-control form-control-solid p-4"
                                v-model="hafezliAnsForm_tasks[ti][qi]['value']" type="text"
                                :class="formDisabled ? hafezliAnsForm_tasks[ti][qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                                placeholder="Answer here" />
                              <div v-if="formDisabled && hafezliAnsForm_tasks[ti][qi]['value'] != quiz.answer[0]"
                                class="border border-success bg-light w-100 mt-2 rounded p-4"
                              >
                                {{ quiz.answer[0] }}
                              </div>
                            </div>
                          </div>
                          <div v-else-if="quiz.type == 'longAns'">
                            <div class="w-100">
                              <textarea v-if="formStatus" :disabled="formDisabled"
                                v-model="hafezliAnsForm_tasks[ti][qi]['value']"
                                class="form-control form-control-solid p-4 mt-2" rows="10"
                                :class="formDisabled ? hafezliAnsForm_tasks[ti][qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                                placeholder="Write down your answer"></textarea>
                              <div v-if="formDisabled && hafezliAnsForm_tasks[ti][qi]['value'] != quiz.answer[0]"
                                class="border border-success bg-light w-100 mt-2 rounded p-4"
                              >
                                {{ quiz.answer[0] }}
                              </div>
                            </div>
                          </div>
                          <div v-else-if="quiz.type == 'clozeTest' || quiz.type == 'blank'">
                            <div class="row justify-content-center align-items-center">
                              <div v-for="(o, oi) in quiz.answer"
                                class="px-7 py-5 col-12 col-lg-6 d-flex flex-column justify-content-between align-items-center"
                                :class="o.length > 0 ? '' : 'd-none'" :key="o">
                                <input v-if="formStatus" class="form-control form-control-solid p-4 w-100"
                                  v-model="hafezliAnsForm_tasks[ti][qi]['value'][oi]" type="text"
                                  :class="formDisabled ? hafezliAnsForm_tasks[ti][qi]['value'][oi] == quiz.answer[oi] ? 'border-success' : 'border-danger' : ''"
                                  :placeholder="`Blank ${oi + 1} answer`" :disabled="formDisabled" />
                                <div v-if="formDisabled && hafezliAnsForm_tasks[ti][qi]['value'][oi] != quiz.answer[0]"
                                class="border border-success bg-light w-100 mt-2 rounded p-4 w-100"
                              >
                                {{ quiz.answer[oi] }}
                              </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div v-else-if="quiz.type == 'matching'">
                            In developing ...
                            <div class="d-none w-100">
                              <div class="d-flex flex-column justify-content-center align-items-center">
                                <div v-for="o in f.matchingOptions"
                                  class="mt-3 d-flex flex-row justify-content-between align-items-center" :key="o">
                                  <button type="button" class="btn btn-secondary">{{ o.text }}</button>
                                  <button type="button" class="btn btn-secondary">{{ o.ans }}</button>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-center mt-5">
                <button v-if="!formDisabled" type="button" class="btn btn-primary"
                  @click="submitAnswer('tasks')">
                  Submit your Answer
                </button>
              </div>
            </div>
            <div v-else-if="sessionStep == 'followUp'" class="card-body">
              <h1>
                {{ hafezliCur_Unit_Lesson["followUp"]['title'] }}
              </h1>
              <p>
                {{ hafezliCur_Unit_Lesson["followUp"]['summary'] }}
              </p>
              <div>
                <div v-for="(file, fi) in hafezliCur_Unit_Lesson['followUp']['files']"
                  :key="fi" class="mt-10 w-100">
                  <div
                    v-if="(typeof file == 'string' && file && file.split('.') && commonVideosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) || (file['filename'] && file['filename'].split('.') && commonVideosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <video controls controlsList="nodownload" class="w-100 h-400px rounded" style="object-fit: contain">
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="video/mp4" />
                      Your browser does not support the audio tag.
                    </video>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                      <!-- <div v-if="part['formObj'] && part['formObj']['formJson'] && part['formObj']['formJson'][fi] && !part['formObj']['formJson'][fi]['ansStatus']" class="d-flex flex-center my-5">
                        <button type="button" class="btn btn-primary" @click="submitAnswer(part['formObj'], 0)">Submit your Answer</button>
                      </div> -->
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file.split('.') && file.split('.').length > 0 && commonAudiosExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonAudiosExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)">
                    <audio class="w-100" controls>
                      <source
                        :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']}`"
                        type="audio/mpeg" />
                      Your browser does not support the audio tag.
                    </audio>
                    <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                      <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                        placeholder="Write down your answer"></textarea>
                    </div>
                  </div>
                  <div
                    v-else-if="(typeof file == 'string' && file && file.split('.') && file.split('.').length > 0 && commonImagesExt.indexOf(file.split('.')[1].toLowerCase()) > -1) ||
                      (file['filename'] && file['filename'].split('.') && commonImagesExt.indexOf(file['filename'].split('.')[1].toLowerCase()) > -1)"
                    class="row justify-content-center align-items-center">
                    <div class="mb-10 col-12 p-3">
                      <a class="d-block overlay cursor-pointer" @click="softBox(file)">
                        <div
                          class="overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded w-100 h-200px bg-secondary"
                          :style="`background-image: url(${backendHost}/uploads/${$store.state.uploadsPath}/${typeof file == 'string' ? file : file['filename']});`">
                        </div>
                        <div class="overlay-layer card-rounded bg-dark bg-opacity-25">
                          <i class="bi bi-eye-fill fs-2x text-white"></i>
                        </div>
                      </a>
                      <div v-if="hafezliCur_Unit_Lesson['lead']['question']">
                        <textarea class="form-control form-control-solid p-4 mt-2" name="" id="" rows="3"
                          placeholder="Write down your answer"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h2 class="mt-10">
                Description
              </h2>
              <div v-html="hafezliCur_Unit_Lesson['followUp']['description']">
              </div>
              <!-- <textarea v-if="formStatus" :disabled="formDisabled"
                v-model="hafezliAnsForm[displayStep - 1]['followUp']"
                class="form-control form-control-solid p-4 mt-2" rows="10"
                placeholder="Write down your answer"></textarea>
              <div class="d-flex flex-center mt-5">
                <button v-if="!formDisabled" type="button" class="btn btn-primary" @click="submitAnswer(quiz, qi)">
                  Submit your Answer
                </button>
              </div> -->
              <div
                v-if="hafezliCur_Unit_Lesson['followUp'].quizes[0].question.length > 0"
                class="border border-1 rounded border-dashed border-gray-400 p-3 mt-10">
                <h2>Quiz</h2>
                <div
                  v-if="hafezliCur_Unit_Lesson && hafezliCur_Unit_Lesson['followUp'] && hafezliCur_Unit_Lesson['followUp'].quizes">
                  <div v-for="(quiz, qi) in hafezliCur_Unit_Lesson['followUp'].quizes"
                    :key="qi" class="d-flex flex-column mb-5"
                    :class="qi < hafezliCur_Unit_Lesson['followUp'].quizes.length - 1 ? 'pb-3 border-bottom border-bottom-1 border-dark' : ''">
                    <!-- <h4>QA {{ fi + 1 }}. <span v-html="f.question"></span></h4> -->
                    <div class="mb-5 w-100" v-if="quiz.type == 'clozeTest'">
                      <div
                        class="w-100 border border-dark rounded row justify-content-center align-items-center p-3 gap-1">
                        <span v-for="o in quiz.answer" :key="o"
                          class="border border-1 border-dark rounded fs-6 col text-center p-2"
                          :class="o.length > 0 ? '' : 'd-none'">{{ o }}</span>
                      </div>
                    </div>
                    <p class="fs-1" v-html="quiz.question"></p>
                    <h6 v-if="quiz.summary && quiz.summary.length > 0" class="text-danger ms-2">
                      Tip: {{ quiz.summary }}
                    </h6>
                    <h6 v-if="quiz.reference && quiz.reference.length > 0" class="text-dark ms-2">
                      Reference: {{ quiz.reference }}
                    </h6>
                    <div>
                      <div v-if="quiz.type == '2choices' || quiz.type == '3choices' || quiz.type == '4choices'">
                        <div class="row justify-content-center align-items-center">
                          <div v-for="o in quiz.answer" class="px-7 py-5 col-12 col-lg-6 p-2"
                            :class="o.length > 0 ? '' : 'd-none'" :key="o">
                            <div
                              class="col-12 d-flex flex-row justify-content-between align-items-center border border-dark border-dashed rounded p-5"
                              :class="formDisabled && o == quiz.answer[0] ? 'border-success' : 'border-dark'"
                            >
                              <label class="col-11 fs-5 fw-bolder form-label m-0">
                                <img v-if="commonImagesExt.indexOf(o.split('.')[1]) > -1" class="w-100 rounded"
                                  :src="`${backendHost}/uploads/${$store.state.uploadsPath}/${o}`" :alt="o">
                                <span v-else>{{ o }}</span>
                              </label>
                              <input v-if="formStatus" :disabled="formDisabled"
                                :checked="formDisabled && o == hafezliAnsForm_followUp[qi]['value']"
                                :class="formDisabled && o == quiz.answer[0] ? 'border-success bg-success' : 'border-dark'"
                                type="radio" class="form-check-input p-4" @click="setRadioGroup('followUp')"
                                :name="`${quiz.type}_${qi}`" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'shortAns'">
                        {{ formStatus }}
                        <div class="w-100">
                          <input v-if="formStatus" :disabled="formDisabled" class="form-control form-control-solid p-4"
                            v-model="hafezliAnsForm_followUp[qi]['value']" type="text"
                            :class="formDisabled ? hafezliAnsForm_followUp[qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                            placeholder="Answer here" />
                          <div v-if="formDisabled && hafezliAnsForm_followUp[qi]['value'] != quiz.answer[0]"
                            class="border border-success bg-light w-100 mt-2 rounded p-4"
                          >
                            {{ quiz.answer[0] }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'longAns'">
                        <div class="w-100">
                          <textarea v-if="formStatus" :disabled="formDisabled"
                            v-model="hafezliAnsForm_followUp[qi]['value']"
                            class="form-control form-control-solid p-4 mt-2" rows="10"
                            :class="formDisabled ? hafezliAnsForm_followUp[qi]['value'] == quiz.answer[0] ? 'border-success' : 'border-danger' : ''"
                            placeholder="Write down your answer"></textarea>
                          <div v-if="formDisabled && hafezliAnsForm_followUp[qi]['value'] != quiz.answer[0]"
                            class="border border-success bg-light w-100 mt-2 rounded p-4"
                          >
                            {{ quiz.answer[0] }}
                          </div>
                        </div>
                      </div>
                      <div v-else-if="quiz.type == 'clozeTest' || quiz.type == 'blank'">
                        <div class="row justify-content-center align-items-center">
                          <div v-for="(o, oi) in quiz.answer"
                            class="px-7 py-5 col-12 col-lg-6 d-flex flex-column justify-content-between align-items-center"
                            :class="o.length > 0 ? '' : 'd-none'" :key="o">
                            <input v-if="formStatus" class="form-control form-control-solid p-4 w-100"
                              :class="formDisabled ? hafezliAnsForm_followUp[qi]['value'][oi] == quiz.answer[oi] ? 'border-success' : 'border-danger' : ''"
                              v-model="hafezliAnsForm_followUp[qi]['value'][oi]" type="text"
                              :placeholder="`Blank ${oi + 1} answer`" :disabled="formDisabled" />
                            <div v-if="formDisabled && hafezliAnsForm_followUp[qi]['value'][oi] != quiz.answer[oi]"
                              class="border border-success bg-light w-100 mt-2 rounded p-4"
                            >
                              {{ quiz.answer[oi] }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div v-else-if="quiz.type == 'matching'">
                        In developing ...
                        <div class="d-none w-100">
                          <div class="d-flex flex-column justify-content-center align-items-center">
                            <div v-for="o in f.matchingOptions"
                              class="mt-3 d-flex flex-row justify-content-between align-items-center" :key="o">
                              <button type="button" class="btn btn-secondary">{{ o.text }}</button>
                              <button type="button" class="btn btn-secondary">{{ o.ans }}</button>
                            </div>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-center mt-5">
                <button v-if="!formDisabled && hafezliCur_Unit_Lesson['followUp'].quizes[0].question.length > 0" type="button" class="btn btn-primary" @click="submitAnswer('followUp')">
                  Submit your Answer
                </button>
              </div>
            </div>
            <div v-else>
              Unavailable page
            </div>
          </div>
          <!-- <div v-else>
            Unit: {{ hafezliCur_Unit }} - Lesson: {{ hafezliCur_Lesson }} - Activity: {{ sessionStep }}
            {{ hafezliCur_Unit_Lesson }}
          </div> -->
        </div>
        <div v-if="false" class="mt-10 w-100">
          <div class="card card-bordered p-5">
            <div class="card-header p-10">
              <h2>Comments</h2>
            </div>
            <div class="card-body p-10">
              <div v-if="comments == 0" class="text-center fw-bold text-gray-500">
                No comments yet
              </div>
              <div v-else>
                <div v-for="comment in comments" :key="comment"
                  class="mb-2 p-5 border border-1 border-gray-300 rounded d-flex flex-column gap-2 align-items-center">
                  <div class="col-12 d-flex flex-row align-items-center justify-content-start gap-2">
                    <span class="symbol symbol-30px"><img class="rounded-circle"
                        :src="comment.commentUser && comment.commentUser > 0 ? `${backendHost}/uploads/${$store.state.uploadsPath}/${comment.profilePhoto}` : '/assets/images/avatars/blank.png'"
                        alt=""></span>
                    <span class="col-auto">{{ comment.commentUser && comment.commentUser > 0 ? comment.profileFullName :
                      "Unknown" }}</span>
                    <span class="col">- {{ comment.commentDate }}</span>
                  </div>
                  <div class="separator w-100"></div>
                  <div class="col-12">
                    <p class="fs-4">{{ comment.commentDescription }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer p-10">
              <form class="form">
                <div class="d-flex flex-column">
                  <textarea maxlength="3000" :dir="routeLocale ? routeLocale : 'ltr'"
                    placeholder="Write down your comment" v-model="commentDescription" rows="5"
                    class="form-control form-control-solid"></textarea>
                  <span class="text-end">{{ commentDescription.length }}/3000</span>
                </div>
                <div class="w-100 d-flex flex-center">
                  <button type="button" class="mt-5 btn btn-sm btn-primary" @click="createComment()">
                    Submit comment
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FsLightbox :toggler="toggler" :sources="softBoxSource" />
    <answer-dialog v-if="dialogDisplay" :modalInfo="answerInfo" @close-modal="setModalConfigs"></answer-dialog>
    <upload-assets v-if="modalDisplay" :contents="null" :modalInfo="uploadInfo" :mode="'single'"
      :modalType="'uploadselect'" @close-modal="setModalConfigs"></upload-assets>
  </div>
</template>

<script>
import dataService from '../../../services/data';
import serverConfigs from "../../../configs/server.json";

import UploadAssets from "../../modals/UploadAssets.vue";
import FsLightbox from "fslightbox-vue";
import AnswerDialog from "../../modals/AnswerDialog.vue";
// import Editor from "@tinymce/tinymce-vue";
// import videojs from "video.js";

export default {
  components: {
    UploadAssets,
    AnswerDialog,
    FsLightbox,
    // editor: Editor,
  },
  computed: {
    videoStreamRefCode() {
      return `${this.$store.state.profile.profileUser}${new Date().getTime()}`;
    },
    currentChapter() {
      return this.$route.params.chapter;
    },
    currentSession() {
      return this.$route.params.session;
    },
    backendHost() {
      return serverConfigs["serverDomain"]["host"];
    },
    routeLocale() {
      return this.$route.params.locale;
    },
    studentId() {
      return this.$route.query.student;
    },
    hafezliTableOfContent() {
      console.log(this.$store.state.curProduct.productChapters)
      let tempArray = [{
        title: 'Basic info',
        name: 'basicInfo'
      }]

      for (let i = 0; i < this.$store.state.curProduct.productChapters.length; i++) {
        tempArray.push({
          title: this.$store.state.curProduct.productChapters[i],
          name: 'chapterInfo',
          sessions: []
        })
      }

      return tempArray;
    }
  },
  data() {
    return {
      lessonDisplay: false,
      hafezliSessionStyle: "flex: 0 0 30px; height: 30px;",
      hafezliCur_Unit: -1,
      hafezliCur_Lesson: -1,
      hafezliCur_Session: -1,
      hafezliCur_Unit_Lesson: {},
      hafezliCur_Unit_Lessons: [],
      hafezliCur_Unit_Lesson_Sessions: [
        {
          id: '1',
          title: 'Step one',
          name: 'lead'
        },
        {
          id: '2',
          title: 'Step two',
          name: 'tasks'
        },
        {
          id: '3',
          title: 'Step three',
          name: 'followUp'
        }
      ],
      commonImagesExt: ["apng", "gif", "ico", "cur", "jpg", "jpeg", "jfif", "pjpeg", "pjp", "png", "svg", "webp"],
      commonVideosExt: ["mpg", "mpeg", "avi", "wmv", "mov", "rm", "ram", "swf", "flv", "ogg", "webm", "mp4"],
      commonAudiosExt: ["mid", "midi", "wma", "rm", "ram", "aac", "wav", "ogg", "mp3", "mp4"],
      hafezliAnsForm: [],
      hafezliAnsForm_lead: [],
      hafezliAnsForm_tasks: [],
      hafezliAnsForm_followUp: [],
      answerObj: {
        taskAns: "",
        followupAns: ""
      },
      ansForm: {
        file: []
      },
      formInfo: {},
      formStatus: true,
      formDisabled: false,
      displayStep: 0,
      sessionStep: 'lead',
      answerInfo: {},
      dialogDisplay: false,
      player: null,
      toggler: false,
      softBoxSource: [],
      uploadInfo: {},
      infoImage: {},
      modalDisplay: false,
      commentDescription: "",
      comments: []
    };
  },
  methods: {
    hafezliNewStep(index, name) {
      console.log(index, name)
      
      if (name == "topic") {
        this.displayStep = index
        this.hafezliCur_Unit = index - 1;
        this.readHafezliUnit()
      } else if (name == "lesson") {
        console.log("Here")
        this.hafezliCur_Lesson = index;
        this.hafezliSessionStyle = "flex: 0 0 30px; height: 130px;"
        this.readHafezliLesson()
        this.readMyForm(0, this.sessionStep)
      } else if (name == "session") {
        this.hafezliCur_Session = index
        this.sessionStep = index

        this.readMyForm(0, index)
      } else {
        console.log("Here")
        this.displayStep = 0
        this.hafezliCur_Unit = -1
        this.hafezliCur_Lesson = -1
        this.hafezliCur_Unit_Lessons = []
      }
    },
    readHafezliUnit() {
    
      console.log(this.$store.state.curProduct.productChapters[this.hafezliCur_Unit])
      let data = {
        endPoint: `forms/r/${encodeURIComponent(this.$store.state.curProduct.productChapters[this.hafezliCur_Unit])}`,
        pageNo: 1,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)
          this.hafezliCur_Unit_Lessons = res.data.data[0].formJson.lessons
          console.log(this.hafezliCur_Unit_Lessons)
          // this.hafezliAnsForm = res.data.data[0].formJson
          // this.formInfo = res.data.data[0]
          // this.formStatus = true

          // this.readMyForm();
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : "error",
            title: error.response && error.response.data ? error.response.data.type : "Error",
            text: error.response && error.response.data ? error.response.data.message : error,
          });
        })
    },
    readHafezliLesson() {
      console.log(this.hafezliCur_Unit_Lessons[this.hafezliCur_Lesson])
      let data = {
        endPoint: `forms/r/${encodeURIComponent(this.hafezliCur_Unit_Lessons[this.hafezliCur_Lesson])}`,
        pageNo: 1,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)
          this.hafezliCur_Unit_Lesson = res.data.data[0].formJson[0]
          this.lessonDisplay = true

          console.log('LESSON', this.hafezliCur_Unit_Lesson)
          for (let i in this.hafezliCur_Unit_Lesson) {
            if (i == 'lead' || i == 'followUp') {
              for (let q in this.hafezliCur_Unit_Lesson[i]['quizes']) {
                if (this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == '2choices' ||
                  this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == '3choices' ||
                  this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == '4choices' ||
                  this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == 'shortAns' ||
                  this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == 'longAns'
                ) {
                  if (i == 'followUp') {
                    this.hafezliAnsForm_followUp.push({
                      value: '',
                      class: ''
                    })
                  }
                  if (i == 'lead') {
                    this.hafezliAnsForm_lead.push({
                      value: '',
                      class: ''
                    })
                  }
                } else if (this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == 'clozeTest' ||
                  this.hafezliCur_Unit_Lesson[i]['quizes'][q]['type'] == 'blank'
                ) {
                  if (i == 'followUp') {
                    this.hafezliAnsForm_followUp.push({
                      value: [],
                      class: []
                    })
                  }
                  if (i == 'lead') {
                    this.hafezliAnsForm_lead.push({
                      value: [],
                      class: []
                    })
                  }
                  for (let a in this.hafezliCur_Unit_Lesson[i]['quizes'][q]['answer']) {
                    if (this.hafezliCur_Unit_Lesson[i]['quizes'][q]['answer'][a].length > 0) {
                      if (i == 'followUp') {
                        this.hafezliAnsForm_followUp[q].value.push('')
                        this.hafezliAnsForm_followUp[q].class.push('')
                      }
                      if (i == 'lead') {
                        console.log('Here')
                        this.hafezliAnsForm_lead[q].value.push('')
                        this.hafezliAnsForm_lead[q].class.push('')
                      }
                    }
                  }
                }
              }
            } else if (i == 'tasks') {
              for (let t in this.hafezliCur_Unit_Lesson[i]) {
                this.hafezliAnsForm_tasks.push([])
                for (let q in this.hafezliCur_Unit_Lesson[i][t]['quizes']) {
                  if (this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == '2choices' ||
                    this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == '3choices' ||
                    this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == '4choices' ||
                    this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == 'shortAns' ||
                    this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == 'longAns'
                  ) {
                    console.log('Here')
                    this.hafezliAnsForm_tasks[t].push({
                      value: '',
                      class: ''
                    })
                  } else if (this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == 'clozeTest' ||
                    this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['type'] == 'blank'
                  ) {
                      this.hafezliAnsForm_tasks[t].push({
                        value: [],
                        class: []
                      })

                    for (let a in this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['answer']) {
                      if (this.hafezliCur_Unit_Lesson[i][t]['quizes'][q]['answer'][a].length > 0) {
                        this.hafezliAnsForm_tasks[t][q].value.push('')
                        this.hafezliAnsForm_tasks[t][q].class.push('')
                      }
                    }
                  }
                }
              }
            }
          }

          console.log('ANSForm lead', this.hafezliAnsForm_lead)
          console.log('ANSForm tasks', this.hafezliAnsForm_tasks)
          console.log('ANSForm followUp', this.hafezliAnsForm_followUp)
          
          // this.hafezliAnsForm = res.data.data[0].formJson
          // this.formInfo = res.data.data[0]
          // this.formStatus = true

          // this.readMyForm();
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : "error",
            title: error.response && error.response.data ? error.response.data.type : "Error",
            text: error.response && error.response.data ? error.response.data.message : error,
          });
        })
    },
    submitAnswer(ti) {
      console.log(this.hafezliCur_Lesson, ti)
      console.log(this.hafezliCur_Unit_Lesson[ti].quizes)
      console.log(this.hafezliAnsForm_tasks)

      if (ti == 'lead' || ti == 'followUp') {
        for (let i in this.hafezliCur_Unit_Lesson[ti].quizes) {
          if (this.hafezliCur_Unit_Lesson[ti].quizes[i].type == '2choices' ||
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == '3choices' ||
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == '4choices'
          ) {
            if (ti == 'lead') {
              if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[0] ==
                this.hafezliAnsForm_lead[i].value
              ) {
                this.hafezliAnsForm_lead[i].class = 'text-success border-success bg-success'
              } else {
                this.hafezliAnsForm_lead[i].class = 'text-danger border-danger bg-danger'
              }
            } else if (ti == 'followUp') {
              if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[0] ==
                this.hafezliAnsForm_followUp[i].value
              ) {
                this.hafezliAnsForm_followUp[i].class = 'text-success border-success bg-success'
              } else {
                this.hafezliAnsForm_followUp[i].class = 'text-danger border-danger bg-danger'
              }
            }
          } else if (
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == 'shortAns' ||
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == 'longAns'
          ) {
            if (ti == 'lead') {
              if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[0] ==
                this.hafezliAnsForm_lead[i].value
              ) {
                this.hafezliAnsForm_lead[i].class = 'border-success'
              } else {
                this.hafezliAnsForm_lead[i].class = 'border-danger'
              }
            } else if (ti == 'followUp') {
              if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[0] ==
                this.hafezliAnsForm_followUp[i].value
              ) {
                this.hafezliAnsForm_followUp[i].class = 'border-success'
              } else {
                this.hafezliAnsForm_followUp[i].class = 'border-danger'
              }
            }
          } else if (
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == 'clozeTest' ||
            this.hafezliCur_Unit_Lesson[ti].quizes[i].type == 'blank'
          ) {
            for (let a in this.hafezliCur_Unit_Lesson[ti].quizes[i].answer) {
              if (ti == 'lead') {
                if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[a] ==
                  this.hafezliAnsForm_lead[i].value[a]
                ) {
                  this.hafezliAnsForm_lead[i].class[a] = 'border-success'
                } else {
                  this.hafezliAnsForm_lead[i].class[a] = 'border-danger'
                }
              } else if (ti == 'followUp') {
                if (this.hafezliCur_Unit_Lesson[ti].quizes[i].answer[a] ==
                  this.hafezliAnsForm_followUp[i].value[a]
                ) {
                  this.hafezliAnsForm_followUp[i].class[a] = 'border-success'
                } else {
                  this.hafezliAnsForm_followUp[i].class[a] = 'border-danger'
                }
              }
            }
          }
        }
      }

      let formJson = {}
      if (ti == 'lead') {
        formJson = this.hafezliAnsForm_lead
      } else if (ti == 'followUp') {
        formJson = this.hafezliAnsForm_followUp
      } else if (ti == 'tasks') {
        formJson = this.hafezliAnsForm_tasks
      }

      let ansFormObj = {
        formName: `${this.$store.state.profile.profileFullName.replace(/ /g, '_')}::${this.$store.state.curProduct.productName.replace(/ /g, '_')}::${this.$store.state.curProduct.productChapters[this.hafezliCur_Unit].replace(/ /g, '_')}::${this.hafezliCur_Unit_Lessons[this.hafezliCur_Lesson].replace(/ /g, '_')}::${ti}::quiz`,
        formCategory: 1,
        formTags: [],
        formTemplate: 1,
        formJson: formJson,
        formDescription: ""
      }

      this.createForms(ansFormObj)

      this.readMyForm(0, ti)
      // formObj['answerStatus'] = "!"
      // if (type == 'tasks') {
      //   if (this.hafezliAnsForm[this.displayStep - 1][type][ti]['quizes'][index][0] == formObj['answer'][0]) {
      //     alert('Correct')
      //   } else {
      //     alert('Wrong')
      //   }
      // }
      // this.formInfo['formJson'] = this.hafezliAnsForm;

      // if (this.formInfo['formParent']) {
      //   this.updateForms(this.formInfo)
      // } else {
      //   this.createForms(this.formInfo)
      // }
    },
    setModalConfigs(opt, index) {
      switch (opt) {
        case "choose":
          if (!this.$store.state.curProduct.productChapters[this.displayStep - 1]['sessionFramework'][index.root]['formObj']['formJson'][index.index]['ansStatus']) {
            this.infoImage = index;

            this.getUploads();
          }
          break;
        case "photo":
          for (let i in index.image) {
            if (typeof index.image[i] == 'object') {
              index.image[i] = index.image[i].filename
            }
          }
          this.$store.state.curProduct.productChapters[this.displayStep - 1]['sessionFramework'][this.infoImage.root]['formObj']['formJson'][this.infoImage.index][this.infoImage.name] = index.image
          this.modalDisplay = false
          document.getElementById("kt_body").style.overflow = "";
          break;
        default:
          this.modalDisplay = false;
          break;
      }
    },
    softBox(src) {
      if (typeof src == 'object') {
        this.softBoxSource = []
        for (let i in src) {
          this.softBoxSource.push(`${this.backendHost}/uploads/${this.$store.state.uploadsPath}/${src[i]}`);
        }
      } else {
        this.softBoxSource.push(`${this.backendHost}/uploads/${this.$store.state.uploadsPath}/${src}`);
      }

      this.toggler = !this.toggler;
    },
    getUploads() {
      let data = {
        endPoint: `uploads`,
        locale: "fa",
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        // query: {
        //   type: "blog",
        // },
      };
      // data.query = JSON.stringify(data.query)
      //   .replace("{", "")
      //   .replace(",", "&")
      //   .replace("}", "")
      //   .replace(/":"/g, "=")
      //   .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          this.uploadInfo = {
            images: res.data.data.reverse(),
            current: {
              upload: [],
            },
          };
          let tempImage = [];
          let tempIndex = [];
          let tempUpload = [];
          // let tempPhotos =
          //   this.infoImage && this.infoImage["root"]
          //     ? this.info[this.infoImage["root"]]
          //     : [];
          // let tempPhotos = []
          // for (let j in this.info.photos ||
          //   this.info.sliderSlides ||
          //   tempPhotos) {
          //   for (let i in this.uploadInfo.images) {
          //     if (
          //       (this.info.photos &&
          //         this.uploadInfo.images[i].uploadName ==
          //           this.info.photos[j]) ||
          //       (this.info.sliderSlides &&
          //         this.uploadInfo.images[i].uploadName ==
          //           this.info.sliderSlides[j]) ||
          //       (tempPhotos &&
          //         this.uploadInfo.images[i].uploadName == tempPhotos[j])
          //     ) {
          //       tempIndex.push(this.info.id);
          //       tempImage.push(this.uploadInfo.images[i].uploadName);
          //       tempUpload.push(Number(i));
          //       break;
          //     }
          //   }
          // }
          this.uploadInfo.current = {
            index: tempIndex,
            image: tempImage,
            upload: tempUpload,
          };
          console.log(this.uploadInfo)
          this.modalDisplay = true;
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        });
    },
    setRadioGroup(ti, qi, value, temp) {
      if (ti == 'lead') {
        this.hafezliAnsForm_lead[qi] = {
          value: '',
          class: ''
        }
        this.hafezliAnsForm_lead[qi]['value'] = value
        this.hafezliAnsForm_lead[qi]['class'] = ''
      } else if (temp == "tasks") {
        console.log('HERE TASKS', ti, qi, value)
        this.hafezliAnsForm_tasks[ti][qi]['value'] = value
        this.hafezliAnsForm_tasks[ti][qi]['class'] = ''
      } else if (ti == "followUp") {
        this.hafezliAnsForm_followUp[qi]['value'] = value
        this.hafezliAnsForm_followUp[qi]['class'] = ''
      }

      console.log(this.hafezliAnsForm_tasks)
    },
    readProducts(page) {
      let data = {
        endPoint: `products/r/${this.$store.state.curProduct.id}`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };
      dataService
        .get(data)
        .then((res) => {
          for (let i in res.data.data) {
            res.data.data[i].productDate = new Date(
              res.data.data[i].productDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
          }

          this.$store.commit("setCurProduct", res.data.data[0])
          console.log(this.$store.state.curProduct)

          // if (this.$store.state.projectUUID == '9c54439ca9c54d1091ba9476fdb6d6f0') {
          //   this.readForms(1);
          // }
          // if (page == 1) {
          //   this.totalPages = res.data.totalRes;
          // }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
      // .finally(() => {
      //   this.loaderStatus[1] = true;
      //   this.loaderDone();
      // });
    },
    getChoices(obj) {
      obj.sessionChoices[3] = obj.sessionAnswer;
      let tempArray = []
      Object.assign(tempArray, obj.sessionChoices)
      console.log(tempArray)

      let iii = 0
      let max = 3
      let index = []
      while (iii < 4) {
        let indexTemp = Math.round(Math.random() * max);
        if (iii == 0) {
          index.push(indexTemp)
          iii++;
        } else {
          if (index.indexOf(indexTemp) == -1) {
            index.push(indexTemp)
            iii++;
          }
        }
      }

      console.log(index)
      let temp1 = tempArray[index[0]]
      let temp2 = tempArray[index[1]]
      let temp3 = tempArray[index[2]]
      let temp4 = tempArray[index[3]]

      let t = []
      if (temp1.length > 0) {
        t.push(temp1)
      }
      if (temp2.length > 0) {
        t.push(temp2)
      }
      if (temp3.length > 0) {
        t.push(temp3)
      }
      if (temp4.length > 0) {
        t.push(temp4)
      }
      return t
    },
    getQuestionChoices(obj) {
      let questions = []
      for (let i in obj.sessionChoices) {
        if (obj.sessionChoices[i] && obj.sessionChoices[i]['q'] && obj.sessionChoices[i]['q'].length > 0) {
          questions.push(obj.sessionChoices[i]['q'])
        }
      }

      return questions
    },
    getAnswerChoices(obj) {
      let questions = []
      for (let i in obj.sessionChoices) {
        if (obj.sessionChoices[i] && obj.sessionChoices[i]['a'] && obj.sessionChoices[i]['a'].length > 0) {
          questions.push(obj.sessionChoices[i]['a'])
        }
      }

      return questions
    },
    getAnswer(obj) {
      if (obj.sessionAns && obj.sessionAns.length > 0) {
        this.answerInfo = obj
        this.answerInfo["status"] = obj.sessionAns == obj.sessionAnswer
        this.dialogDisplay = true
      } else {
        alert("لطفا پاسخ خود را وارد نمایید.")
      }
    },
    nextContentOfTable() {
      this.displayStep += 1
    },
    previousContentOfTable() {
      this.displayStep -= 1
    },
    setDisplayStep(index) {
      this.displayStep = index
    },
    updateForms(obj) {
      let data = {
        endPoint: `forms/u/${obj.id}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        data: {
          json: obj['formJson'],
          description: obj['formDescription'],
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your answer has been saved successfully!"
            // text: res.data.message,
          });
          this.readProducts(1)
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    updateUploads(obj) {
      this.$store.commit("setLoader", true);
      let data = {
        endPoint: `uploads/u/${obj.id ? obj.id : 0}`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {
          name: obj["uploadName"],
          description: obj["uploadDescription"],
          category: obj["uploadCategory"],
        },
      };

      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.resetUploadInfo();
          this.getUploads();
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          this.$store.commit("setLoader", false);

        });
    },
    createComment() {
      let data = {
        endPoint: `comments`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        data: {
          category: this.$store.state.curProduct.productCategory,
          description: this.commentDescription,
          tags: [],
          object: this.$store.state.curProduct.id,
          title: "New comment about package"
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: res.data.message,
          });
          this.commentDescription = ""
          this.readComments(1);
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    readComments(page) {
      let data = {
        endPoint: `comments`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        query: {
          object: `${this.$store.state.curProduct.id}`,
          category: `${this.$store.state.curProduct.productCategory}`,
        },
      };
      data.query = JSON.stringify(data.query)
        .replace("{", "")
        .replace(",", "&")
        .replace("}", "")
        .replace(/":"/g, "=")
        .replace(/"/g, "");
      dataService
        .get(data)
        .then((res) => {
          for (let i in res.data.data) {
            console.log(res.data.data)
            res.data.data[i].commentDate = new Date(
              res.data.data[i].commentDate
            ).toLocaleDateString(this.routeLocale, {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
          }

          this.comments = res.data.data
          // if (page == 1) {
          //   this.totalPages = res.data.totalRes;
          // }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
      // .finally(() => {
      //   this.loaderStatus[1] = true;
      //   this.loaderDone();
      // });
    },
    createForms(obj) {
      let data = {
        endPoint: `forms`,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        data: {
          // parent: obj['id'],
          name: obj['formName'],
          category: obj['formCategory'],
          tags: obj['formTags'],
          template: obj['formTemplate'],
          json: obj['formJson'],
          description: obj['formDescription']
        },
      };
      dataService
        .post(data)
        .then((res) => {
          this.$notify({
            type: res.data.type,
            title: res.data.type,
            text: "Your answer has been saved successfully!"
            // text: res.data.message,
          });
          this.readProducts(1)
        })
        .catch((error) => {
          this.$notify({
            type: error.response.data.type,
            title: error.response.data.type,
            text: error.response.data.message,
          });
        })
    },
    readForms(page) {
      let data = {
        endPoint: `forms/r/hafezli_${this.$store.state.curProduct.id}`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
      };

      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)
          this.hafezliAnsForm = res.data.data[0].formJson
          this.formInfo = res.data.data[0]
          this.formStatus = true

          this.readMyForm();
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : "error",
            title: error.response && error.response.data ? error.response.data.type : "Error",
            text: error.response && error.response.data ? error.response.data.message : error,
          });
        })
      // .finally(() => {
      //   this.loaderStatus[1] = true;
      //   this.loaderDone();
      // });
    },
    readMyForm(page, ti) {
      this.formDisabled = false
      console.log(this.studentId)
      let data = {
        endPoint: `forms/r/${encodeURIComponent(this.$store.state.profile.profileFullName.replace(/ /g, '_'))}::${encodeURIComponent(this.$store.state.curProduct.productName.replace(/ /g, '_'))}::${encodeURIComponent(this.$store.state.curProduct.productChapters[this.hafezliCur_Unit].replace(/ /g, '_'))}::${encodeURIComponent(this.hafezliCur_Unit_Lessons[this.hafezliCur_Lesson].replace(/ /g, '_'))}::${ti}::quiz`,
        pageNo: page,
        locale: `${this.routeLocale}`,
        token: this.$store.state.token,
        uuid: this.$store.state.projectUUID,
        data: {},
        // query: {
        //   ref: this.studentId ? this.studentId : "me",
        // },
      };
      // data.query = JSON.stringify(data.query)
      //   .replace("{", "")
      //   .replace(",", "&")
      //   .replace("}", "")
      //   .replace(/":"/g, "=")
      //   .replace(/"/g, "");

      dataService
        .get(data)
        .then((res) => {
          console.log(res.data.data)

          if (res.data.data.length > 0) {
            console.log(res.data.data)
            if (ti == 'lead') {
              this.hafezliAnsForm_lead = res.data.data[0].formJson
            } else if (ti == 'followUp') {  
              this.hafezliAnsForm_followUp = res.data.data[0].formJson
            } else if (ti == 'tasks') {
              this.hafezliAnsForm_tasks = res.data.data[0].formJson
            }
            this.formDisabled = true
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: error.response && error.response.data ? error.response.data.type : "error",
            title: error.response && error.response.data ? error.response.data.type : "Error",
            text: error.response && error.response.data ? error.response.data.message : error,
          });
        })
      // .finally(() => {
      //   this.loaderStatus[1] = true;
      //   this.loaderDone();
      // });
    },
  },
  mounted() {
    // this.readComments(1);
    this.readProducts()
  },
};
</script>

<style>
p>img {
  width: 100%;
}

.h-lesson-30 {
  height: 30px !important;
}

.h-lesson-130 {
  height: 130px !important;
}
</style>